export default __webpack_public_path__ + "static/media/admin.497b5e3b.svg";